<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western2" id="calibre_pb_10"><a id="CHAPTER04"></a>
CHAPTER 4</h1>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c8">JOURNAL ENTRY: August 2</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c9">The gray and dismal clouds we’ve been having for the
past two days moved out before noon and left us with a beautiful
blue sky, sunshine and a pleasant seventy-five degrees.</p>
<p class="c"> <br class="calibre2"/></p>
<p class="c">*</p>
<p class="c"> <br class="calibre2"/></p>
<p class="western1">“Are you getting nervous, Mark?” I asked my
intended over a light lunch that he had barely touched.</p>
<p class="western1">“A little,” he replied, pushing his plate
aside. “Aren’t you?”</p>
<p class="western1">“Somewhat, yes, although I’m more nervous for
the reception than the wedding. I’ve never been surer of a decision
than I am about marrying you,” I said with a sincere smile.</p>
<p class="western1">“I think you were born to entertain, Allex,”
Mark snorted. “In three days you have put together a party for a
dozen people and done most of the cooking, too.”</p>
<p class="western1">“Oh, that’s not true, Mark. Kathy is doing a
dish, plus something else she won’t tell me about. Amanda is making
several dishes, and Emilee is trying her hand at making mini-sweet
rolls for desert,” I reminded him. “I’m left with making the bread
rolls and a spaghetti salad. That’s all. That does remind me that I
need to do the next step with those rolls or they won’t be done in
time.” I set our bowls in the sink full of warm, soapy water after
scraping the bread crusts into a bowl for the chickens.</p>
<p class="western1">“While you do that, would you like me to take
care of the chickens?” Mark asked, nuzzling the back of my
neck.</p>
<p class="western1">Now that the birds were back out in their
coop, it was a bit more time consuming to haul water out to them.
Having them in the greenhouse for their daily feeding and watering
was convenient though it was nice to have the increasing odor away
from the house again.</p>
<p class="western1">“That would be wonderful, thank you.” I
really did have more things to do. The least of all was to choose a
dress to wear.</p>
<p class="western1">I set the bread on the next rise and then
filled a pot of water to cook the pasta for the spaghetti salad. I
decided on using multiple shaped pasta to make it fun: bow ties,
penne, spirals, and shells, whatever I could find. I knew it would
be limited because of not having certain fresh things like green
onions, cukes, green pepper and cherry tomatoes, though I doubted
anyone would notice that there were only sliced black olives,
canned tomatoes, and rehydrated onions with the pasta.</p>
<p class="western1">After I drained the cooked pasta, I drenched
it with my remaining half bottle of Italian dressing and added the
few extras. It would have to do.</p>
<p class="western1">The rolls were formed and on the final rise,
so I took a shower and started getting ready. Kathy and Bob arrived
early so Kathy could help with any last minute things, and Bob kept
a nervous Mark occupied.</p>
<p class="western1">“Have you decided on a dress, Allexa?” Kathy
asked, flipping through my closet.</p>
<p class="western1">“I was thinking about this one.” I pulled a
hanger out from the back of the half bath door. It was a soft sage
green, with a long skirt, long sleeves, and a deep V neckline. It
was plain, but I thought it lovely and wearing it made me feel
good.</p>
<p class="western1">“Oh! That is very pretty, Allexa! I don’t
think I’ve seen it before. When did you get it?”</p>
<p class="western1">“Actually, it’s sort of new. I bought it last
year because it just called to me. It was a size too small then, so
it’s hung it the closet. Now that I’ve lost almost thirty pounds
since November, it fits perfectly, even a bit loosely. I know it’s
rather plain, but I love the color.”</p>
<p class="western1">“I think it will be perfect,” Kathy said.
“Can I pick out earrings for you?”</p>
<p class="western1">I agreed. She selected two pairs for my
double piercing; one simple gold chains and the other long and
sparkling.</p>
<p class="western1">“What about wedding rings, Allex?” she
asked.</p>
<p class="western1">“I hadn’t given it much thought,” I said, and
a touch of panic hit me until a memory slid to the front of my
thoughts. “I have an idea.” I opened a glass box on my dresser.
“This box was specially made by a stained glass artist the year my
mother died,” I explained to Kathy. “He inlaid dried Bleeding Heart
flowers that were picked from the plant my father gave my mother
for their twenty-fifth wedding anniversary.” I opened the box to
reveal my parents’ wedding bands. “I know Mother’s ring fits me,
perhaps Dad’s will fit Mark.”</p>
<p class="western1">“What a lovely gesture,” Kathy said, taking
the rings from me. “Don’t worry, I won’t lose them. I want to
polish them up.” She left me to finish combing my hair.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">At three thirty, our guests started arriving.
Amanda took over arranging things on the food table, while Kathy
kept me in the greenhouse so Mark could shower and change
clothes.</p>
<p class="western1">“Keeping Mark and I apart is silly, Kathy!
We’ve been living together for the last two weeks,” I said, pacing,
and then sitting on the bench by the fish pond, the water gurgling
happily from the full batteries. There has fortunately been enough
sunlight that the solar panels have kept the batteries charged.</p>
<p class="western1">“Tough!” she said. “Stay here. I have
something for you I need to get from the car.” She left, leaving
the door open. The breeze it brought in was welcomed and it helped
to soothe my growing anxiety.</p>
<p class="western1">When she returned, she had a bouquet of
flowers! It was made up of a hodgepodge of baby’s breath, zinnia in
bright yellow, wild ox-eyed daisies, blue forget-me-nots, and a
single rose. The combination was stunning, and I almost cried over
her thoughtfulness.</p>
<p class="western1">At four o’clock sharp, she let me out of the
greenhouse to greet my guests and my soon to be husband.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">“You look stunning,” Mark said as he took my
hand and walked with me to where our friends and family waited with
Pastor Carolyn.</p>
<p class="western1">When we said our vows, Mark added some of his
own. “And I promise to never, ever leave you. It’s until death do
us part. Now that I’ve said that in front of everyone, you will
have to believe me.”</p>
<p class="western1">When Carolyn called for rings, Mark looked
panic stricken.</p>
<p class="western1">“Don’t worry, Mark, we got it covered, I hope
yours fits,” I whispered to him. Jacob walked up to Carolyn and
held out his hands. The newly polished gold rings sparkled in the
sunlight.</p>
<p class="western1">“Anything you would like to say about these
rings, Allexa?” Carolyn asked.</p>
<p class="western1">I turned to my new husband and said “These
are my parents’ wedding rings. I think they would be very pleased
that you and I are now going to wear them.” I slid my father’s ring
onto Mark’s finger to find a perfect fit. He took the other ring
from Jacob and placed it on my finger.</p>
<p class="western1">“I now pronounce you man and wife,” Pastor
Carolyn announced proudly.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">“It was all lovely, though I hadn’t expected
for us to make such a big deal over getting married,” I confessed
to Mark as we accepted a glass of wine from Bob.</p>
<p class="western1">“I think it was just enough, Allex,” Mark
said, giving me yet another kiss. “Your family and friends wanted
this, and who are we to deny them?”</p>
<p class="western1">Right before we were ready to start our
buffet feast, which included a wedding cake Kathy had made and
decorated with fresh nasturtiums, a vehicle was heard coming down
the road. The military Humvee came to a stop across from our
group.</p>
<p class="western1">Both the driver’s door and the passenger side
opened at the same time. The driver stepped out, holding a rifle,
while the passenger walked around the vehicle and came up to
us.</p>
<p class="western1">“Good afternoon, everyone, I’m Captain
Andrews of the United States Army,” he introduced himself. “This
looks like a celebration of some sort.”</p>
<p class="western1">“It’s a wedding, Captain. Can we help you?” I
said, noting something about him was familiar.</p>
<p class="western1">“Congratulations to the happy couple,” he
said. “I’ve come to Moose Creek to see if there is anyone who needs
assistance in relocating to Marquette.”</p>
<p class="western1">“I don’t think there is anyone left in Moose
Creek, Captain. I believe any survivors have already moved to
town,” Anna said.</p>
<p class="western1">“What about everyone here?” he asked
calmly.</p>
<p class="western1">“We’re fine, Captain. We don’t require any
help,” Bob said. “Are you going to force us to leave our
homes?”</p>
<p class="western1">Captain Andrews looked at each one, lingering
on Emilee, and then said, “No. I’m not interested in stressing our
already overloaded system.”</p>
<p class="western1">During this brief conversation, Eric and
Jason came from the house across the street, carrying a case of
Eric’s latest brew. When they saw we had visitors, they quietly set
the beer down and advanced slowly. Even limping, Eric was silent in
his stealth.</p>
<p class="western1">The driver of the Humvee had been standing a
few feet from the truck, far enough for Eric and his brother to
approach from either side. In one swift act, Jason held a knife to
the young soldier’s throat while clamping his other hand over his
mouth. During that same move, on the other side, Eric relieved the
now prone young man of his M4 carbine rifle.</p>
<p class="western1">With the rifle tucked under his right armpit,
and a crutch under his left, Eric advanced silently until he was
within range, and touched the barrel of the rifle to the Captain’s
ribs. Captain Andrews froze.</p>
<p class="western1">“Sargent Rush, I presume.” The captain turned
his head slowly.</p>
<p class="western1">“Sir,” Eric stated, not moving the rifle, and
yet acknowledging the officer’s recognition.</p>
<p class="western1">“I’m not here to make trouble, Sargent,”
Captain Andrews said. “Can you lower that weapon?”</p>
<p class="western1">“No sir, not yet. Mom, will you relieve the
captain of his service revolver?”</p>
<p class="western1">I could tell Eric was in a different mental
zone. I strode forward and took the gun from his service holster
and backed away, out of reach, and set the Beretta M9 on the
table.</p>
<p class="western1">“It appears as if you were right, none of you
need my assistance,” Captain Andrews said, smiling. “If you’re
wondering how I knew it was you, son, I recognized your daughter
from your stay at Sawyer this past winter.”</p>
<p class="western1">“Captain, <i class="calibre4">are</i> you going to force us to
go to Marquette?” I asked.</p>
<p class="western1">“No, ma’am, I’m not. My orders were to clear
out Moose Creek. It’s obvious to me that you’re not <i class="calibre4">in</i> Moose
Creek,” he replied with a friendly grin.</p>
<p class="western1">“Okay. Then would you care to join us for
dinner?”</p>
<p class="western1">“That’s generous of you. Thank you, I think
we will. May I turn around now, Sargent?” he asked. Eric stepped
back, still holding the rifle level.</p>
<p class="western1">When the captain saw his driver face down on
the ground, he chuckled. “A green recruit. Can he get up now?”</p>
<p class="western1">As the young man stood, he asked, “How did
you get the drop on me so easily?”</p>
<p class="western1">“Too much time spent in The Sandbox,” Eric
replied.</p>
<p class="western1">“Ma’am, you will get no trouble from us, I
promise. Will you ask your son to lower that weapon? It doesn’t
help the digestion having a high powered rifle aimed at you,
especially when it’s in the hands of a trained sniper,” the captain
said. “Sargent, after you arrived last February, I did some
inquiries on your service record.” He looked at Eric’s crutch.
“What happened to your leg?”</p>
<p class="western1">Mark, who had been silent this entire time,
now spoke up. “A wolf tried to include Eric in his dinner plans.
Eric disagreed with the menu.”</p>
<p class="western1">“His foot and calf were mangled pretty badly,
but Mark put him back together,” I said. “We eliminated the threat
- all of them,” I said as steely as I could and with as much
implication as I could manage.</p>
<p class="western1">“You’re a doctor?” The captain’s attention
was now focused on Mark, who responded only by nodding. “We sure
could use you in the city. Please consider joining us.”</p>
<p class="western1">“I’m needed here, but thank you for the
invitation,” Mark said coldly and politely.</p>
<p class="western1">The captain had been eating from a plate put
in front of him, even sipped from the cup of beer set beside him by
a silent Amanda.</p>
<p class="western1">“Captain Andrews, what happened to our two
friends in Moose Creek that were forced to leave a few days ago?” I
said accusingly.</p>
<p class="western1">“I’m sorry, I don’t know anything about
that,” he said calmly, and took another sip from his still full
cup. “I can tell you have a competent and well-rounded group here:
military expertise, hunters, a minister, a doctor, and some
excellent cooks,” he took another sip of beer. “A fine brew-master,
too. If you decide you want to relocate, you would be more than
welcomed. You have some highly desirable talents. We could really
use you, but we won’t force you. If you decide to stay here, we
will let you be.”</p>
<p class="western1">This alarmed me for some reason.</p>
<p class="western1">“Can we discuss this option among ourselves
and get back to you? In say a week?”</p>
<p class="western1">“Yes, I will need a week to pack,” Anna said.
I looked at her sharply.</p>
<p class="western1">“Same here,” Carolyn chimed in.</p>
<p class="western1">He smiled. “I think that can be easily
arranged.” He stood and moved away from the table. “Thank you very
much for your hospitality, but we must be going. When you’re ready
you can reach me by calling 911, dispatch will find me.”</p>
<p class="western1">They drove off without even asking for their
weapons back.</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c">~~~</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">“Anna, Carolyn, do you really want to go to
Marquette?” I asked, shocked.</p>
<p class="western1">“Of course not,” Anna said. “However, if he
thinks some of us <i class="calibre4">do</i> want to be relocated, he might give us
that full week before coming back.”</p>
<p class="western1">“Mom,” Jason spoke up, “do you believe him?
That they will let the rest of us be?”</p>
<p class="western1">“No I don’t,” I said, taking a deep breath.
“We may have bought a few days, however, we need to get out of here
before he comes back with enough troops to <i class="calibre4">take</i> us.”</p>
<p class="western1">“Where will we go?” Amanda asked with a
frown.</p>
<p class="western1">“I don’t know.”</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="c8">~~~</p>
<p class="western1"> <br class="calibre2"/></p>
<p class="western1">The festive mood of the afternoon wedding was
completely doused by Army Captain James Andrews’ visit.</p>
<p class="western1">“Mom,” Eric limped forward, “are we really
leaving here?”</p>
<p class="western1">“I don’t know what we should do,” I said. I
looked at my guests, my friends, my family. Were they still looking
to me to answer their questions, give them guidance? This time I
really felt I was out of my realm.</p>
<p class="western1">“I’ve never known you to run from anything
before,” Jason said, sitting down across from me. “Why do you think
we should leave?”</p>
<p class="western1">“That’s a good question, son. I don’t want to
leave. I’m happy here.” I smiled at my husband of an hour.
“However, I fear for what— or who— may come after us. While Captain
Andrews seems sincere, I don’t know if we can or should trust him.
Eric, you spent a few days with him, what are your thoughts?”</p>
<p class="western1">“I take him for an honest man. I think he
will do his best to keep his word, and if the situation changes, I
believe he will inform us first. I can’t say exactly why I feel
that, but I do,” Eric answered. He lowered himself into a seat next
to Emilee and picked up the captain’s gun, ejecting the magazine.
“Nice gun. Beretta M9, 92A1, fifteen plus one rounds,
double-stacked magazine. Would you mind if I kept this, Mom? That
revolver is only a five shot. This one makes me feel right at
home.” He grinned when I nodded.</p>
<p class="western1">“Tell you what. Let’s not make any decisions
tonight,” I said. “We can regroup in the morning and discuss this
over breakfast,” at which point Mark gave a quiet cough. “Make that
lunch, around noon.” Everyone laughed and I blushed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_648f5cba11b35594391da1bef1608eec_YkgYR9.ch.fixed.fc.tidied.stylehacked.xfixed_split_011.vue?5146f3a7